// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.rsp-fundraiser.merosms.com/main/api/v1';

export const API_CHATBOT_BASE_URL = process.env.REACT_APP_CHATBOT_BASE_URL || 'https://api.chatbot.merosms.com/api/';
// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'rsp_auth_token',
  USER_DATA: 'rsp_user_data',
  REFRESH_TOKEN: 'rsp_refresh_token',
};

// User Roles
export const USER_ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  FINANCE_ADMIN: 'FINANCE_ADMIN',
  CONTENT_ADMIN: 'CONTENT_ADMIN',
  SUPPORT_ADMIN: 'SUPPORT_ADMIN',
};

// KYC Status
export const KYC_STATUS = {
  OPEN: 'OPEN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
};

// Donation Status
export const DONATION_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};

// Target Types
export const TARGET_TYPES = {
  PARTY: 'PARTY',
  CANDIDATE: 'CANDIDATE',
};

// Payment methods – eSewa, ConnectIPS, Khalti (values match backend)
export const PAYMENT_METHODS = [
  { id: 'ESEWA', label: 'eSewa', description: 'Pay via eSewa' },
  // { id: 'CONNECTIPS', label: 'ConnectIPS', description: 'Pay direct from bank' },
  { id: 'KHALTI', label: 'Khalti', description: 'Pay via Khalti' },
  { id: 'VOUCHER', label: 'Voucher Payment', description: 'Pay via Bank Voucher' },
];

// Donation Limits
export const DONATION_LIMITS = {
  MIN: 10,
  MAX: 25000,
};

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 10,
  DEFAULT_OFFSET: 0,
  MAX_LIMIT: 100,
};
